import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { PROPERTY_REPORT } from "./apiRoutes";

interface UseGetPropertyOutstandingDuesProps {
  userId?: string | number;
  propertyIds?: Array<string | number>;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPropertyOutstandingDues = async (
  userId?: string | number,
  propertyIds?: Array<string | number>
) => {
  const params = new URLSearchParams();
  if (userId != null && userId !== "") {
    params.append("userId", String(userId));
  }
  (propertyIds || []).forEach((id) => {
    if (id != null && id !== "") {
      params.append("propertyIds", String(id));
    }
  });
  return await axiosAuth.get(`${PROPERTY_REPORT}/outstanding-dues?${params.toString()}`);
};

const useGetPropertyOutstandingDues = ({
  userId,
  propertyIds,
  queryParams,
}: UseGetPropertyOutstandingDuesProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-outstanding-dues", userId, propertyIds],
    queryFn: () => getPropertyOutstandingDues(userId, propertyIds),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPropertyOutstandingDues;
